export enum EProductType {
    MASTER=1,
    SERVICES=2,
    OTHERS=3,
    LICENSES=4,
    VALIDITY=5,
    DEMO=6,
    CHANGE

}
